import * as React from 'react';
import { styled } from '@linaria/react';

function ButtonPoofy({
  children,
  ...delegated
}: React.HTMLAttributes<HTMLButtonElement>) {
  return (
    <Button {...delegated}>
      <ButtonContent>{children}</ButtonContent>
    </Button>
  );
}

const Button = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: white;
  font-weight: var(--font-weight-medium);
  font-size: 1.125rem;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
  background: linear-gradient(
    15deg,
    var(--poofy-dark, hsl(210deg 30% 10%)),
    var(--poofy-light, hsl(250deg 40% 35%))
  );

  &:focus-visible {
    outline-color: var(--color-primary);
    outline-offset: 4px;
  }

  &:disabled,
  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 2px;
    left: 6px;
    right: 6px;
    height: 20%;
    background: linear-gradient(
      hsl(0deg 0% 100% / 0.3),
      hsl(0deg 0% 100% / 0)
    );
    border-radius: 20px;
    border-top-left-radius: 20px 14px;
    border-bottom-left-radius: 100px 30px;
    border-top-right-radius: 20px 14px;
    border-bottom-right-radius: 100px 30px;
    pointer-events: none;
  }

  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0px;
    left: 0;
    right: 0;
    height: 30%;
    background: linear-gradient(
      hsl(0deg 0% 0% / 0),
      hsl(0deg 0% 0% / 0.17)
    );
    border-radius: 0px 0px 4px 4px;
    pointer-events: none;
  }

  &:active {
    filter: brightness(90%);
  }

  &:active:before {
    top: 0;
    left: 0;
    right: 0;
    height: 30%;
    background: linear-gradient(
      hsl(0deg 0% 0% / 0.17),
      hsl(0deg 0% 0% / 0)
    );
    border-radius: 4px 4px 0px 0px;
  }

  &:active:after {
    top: revert;
    left: 2px;
    right: 2px;
    bottom: 2px;
    height: 20%;
    background: linear-gradient(
      hsl(0deg 0% 100% / 0),
      hsl(0deg 0% 100% / 0.3)
    );
    border-radius: 20px;
    border-bottom-left-radius: 10px 14px;
    border-top-left-radius: 100px 30px;
    border-bottom-right-radius: 10px 14px;
    border-top-right-radius: 100px 30px;
  }
`;

const ButtonContent = styled.span`
  ${Button}:active & {
    transform: scale(0.9);
  }
`;

export default ButtonPoofy;
